// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/** All Sector values, in display order. */
export const SECTOR_VALUES = [
    'banking',
    'insurance',
    'healthcare',
    'ict_critical',
    'telecom',
    'energy',
    'transport',
    'digital_services',
    'digital_technology_industry',
    'public_administration',
    'payments',
    'other',
];
export function isSector(value) {
    return typeof value === 'string' && SECTOR_VALUES.includes(value);
}
//# sourceMappingURL=regulatory.js.map